import Vue from 'vue'
import Router from 'vue-router'
import GetStarted from '@/components/GetStarted'
import GetStartedPaged from '@/components/GetStartedPaged'

import Verify from '@/components/Verify'
Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'GetStarted',
		component: GetStarted
	},
	{
		path: '/verify/',
		name: 'verify',
		component: Verify
	},
	{
		path: '/getstarted/',
		name: 'GetStartedPaged',
		component: GetStartedPaged
	}
	],
	scrollBehavior() {
		document.getElementById('app').scrollIntoView()
	}
},

)


// WEBPACK FOOTER //
// ./src/router/index.js